import * as THREE from 'three';
import { getWorldTransform } from '../../../modules/scene';
import { getThreeCamera } from '../../../modules/player';

const cameraPosition = new THREE.Vector3();
const nodePosition = new THREE.Vector3();
const boundingVector = new THREE.Vector3();
const boundingSphere = new THREE.Sphere();

export default function getBoundingRadius(store, nodeId) {
  const camera = getThreeCamera(store);
  const nodeTransform = getWorldTransform(store, nodeId);
  cameraPosition.setFromMatrixPosition(camera.matrix);

  const boundingRadius = store.getTranslator().getNodeBoundingBox(nodeId).getBoundingSphere(boundingSphere).radius;
  boundingVector.subVectors(cameraPosition, nodePosition);
  boundingVector.z = -boundingVector.length();
  boundingVector.y = boundingRadius;
  boundingVector.x = 0;

  boundingVector.applyMatrix4(camera.projectionMatrix);
  boundingVector.z = 0;
  return boundingVector.length();
}



// WEBPACK FOOTER //
// ./src/translators/tools/utils/getBoundingRadius.js